import { FlamingoTypes } from '@mode/shared/contract-common';

export const FilteredResultsSuffix = '-f';
export const ResultsWithCalcsSuffix = '-c';

export function makeFilteredRefId(queryToken: string) {
  return `${queryToken}${FilteredResultsSuffix}`;
}

export function makeWithCalcsRefId(queryToken: string) {
  return `${queryToken}${ResultsWithCalcsSuffix}`;
}

/**
 * Makes the proper refId from queryToken and resultsType.
 */
export function makeRefIdByResultType(queryToken: string, resultsType: FlamingoTypes.ResultsType) {
  switch (resultsType) {
    case FlamingoTypes.ResultsType.Raw:
      return queryToken;
    case FlamingoTypes.ResultsType.Filtered:
      return makeFilteredRefId(queryToken);
    case FlamingoTypes.ResultsType.WithCalcs:
      return makeWithCalcsRefId(queryToken);
  }
}
